// Returns today's date in the user's local timezone as ISO YYYY-MM-DD.
// We compute it locally (rather than `new Date().toISOString().slice(0,10)`,
// which would be UTC) because "I marked this done today" reflects the
// user's wall clock, not the server's.

export function todayLocalIsoDate(): string {
  const d = new Date();
  const y = String(d.getFullYear()).padStart(4, "0");
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
